import { render, staticRenderFns } from "./WapWXCW03BJRecordWCBJ.vue?vue&type=template&id=6fe810dc&scoped=true&"
import script from "./WapWXCW03BJRecordWCBJ.vue?vue&type=script&lang=js&"
export * from "./WapWXCW03BJRecordWCBJ.vue?vue&type=script&lang=js&"
import style0 from "./WapWXCW03BJRecordWCBJ.vue?vue&type=style&index=0&id=6fe810dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe810dc",
  null
  
)

export default component.exports